// extracted by mini-css-extract-plugin
export default {"btn":"GenConfirm_btn__PS9tH","btnalt":"GenConfirm_btnalt__qWo9q","modal":"GenConfirm_modal__6bbgD","backdrop":"GenConfirm_backdrop__gDjxA"};